export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10745.4b95d0fd.jpg";